import { render, staticRenderFns } from "./tit-wrap-primary.vue?vue&type=template&id=1c20c450&scoped=true&"
import script from "./tit-wrap-primary.vue?vue&type=script&lang=js&"
export * from "./tit-wrap-primary.vue?vue&type=script&lang=js&"
import style0 from "./tit-wrap-primary.vue?vue&type=style&index=0&id=1c20c450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20c450",
  null
  
)

export default component.exports